import { useEffect } from 'react';

function isSameOrigin(targetWindow: Window | null, currentWindow: Window | null = window) {
	let isSameOrigin;
	try {
		isSameOrigin = targetWindow?.location.origin === currentWindow?.location.origin;
	} catch (e) {
		// catch the DOM exception, mark the resolution to "false"
		isSameOrigin = false;
	}
	return isSameOrigin;
}

export const calculateDepth = (hostWindow: Window, offset = 0): number => {
	let currentWindow = hostWindow;
	let hostFrameOffset = 0;

	while (currentWindow && currentWindow !== window.top) {
		hostFrameOffset += 1;
		currentWindow = currentWindow.parent;
	}

	return hostFrameOffset - offset;
};

type WindowWithHostOffsetOverride = Window & {
	getHostOffsetFunctionOverride?: (hostWindow: Window) => number;
};

const attachHostOffsetOverride = (window: Window) => {
	const topWindow = window.top as WindowWithHostOffsetOverride | null;
	if (topWindow) {
		if (isSameOrigin(topWindow)) {
			const containerDepth = calculateDepth(window);
			topWindow.getHostOffsetFunctionOverride = (hostWindow: Window) =>
				calculateDepth(hostWindow, containerDepth + 1);
		}
	}
};

const detachHostOffsetOverride = () => {
	const topWindow = window.top as WindowWithHostOffsetOverride | null;
	if (topWindow) {
		if (isSameOrigin(topWindow)) {
			delete topWindow.getHostOffsetFunctionOverride;
		}
	}
};

export function useHostOffsetOverride(): void {
	useEffect(() => {
		attachHostOffsetOverride(window);
		return () => {
			detachHostOffsetOverride();
		};
	}, []);
}
